window.ourpay_data_mapper = (function () {
    return function (data) {

        var ourpayMode = (data.OurPay && data.OurPay.Settings.OurpayMode) || 0;
        var isEnabled = ourpayMode === 1 || ourpayMode === 3;
        // var isEnabled = data.OurPay && data.OurPay.Settings.IsOurPayEnabled;

        return data.OurPay && {
            MyPayDetails: {
                Amount: data.OurPay.Summary.FirstTransactionAmount,
                BillingAgreement: data.OurPay.Payment.BillingAgreement,
                Enabled: !!isEnabled,
                IsOurPayThreeDSecureRequired: data.OurPay.Settings.IsOurPayThreeDSecureRequired,
                TermsAndConditions: data.OurPay.Settings.TermsAndConditions,
                Message: data.OurPay.Message,
                PaymentConditions: data.OurPay.Payment.PaymentConditions,
                PaymentSchemeDescription: data.OurPay.Summary.Description,
                ReasonCode: data.OurPay.ReasonCode,
                TransactionCount: data.OurPay.Payment.TransactionCount,
                ShowExtraMessage: data.OurPay.Settings.ShowExtraMessage,
                OurpayMode: ourpayMode
            }
        } || {};
    };
})();